/**
 * Smart Documentation Route
 * Shows docs in MainLayout if logged in, PublicLayout if not
 */

import { lazy, Suspense } from 'react'
import { useAuth } from '../contexts/AuthContext'
import MainLayout from './layout/MainLayout'
import PublicLayout from './layout/PublicLayout'

const Documentation = lazy(() => import('../pages/Public/Documentation/Documentation'))

const PageLoader = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    fontSize: '1.2rem',
    color: '#666'
  }}>
    Loading...
  </div>
)

function isPrerenderBuild(): boolean {
  return typeof globalThis !== 'undefined' && Boolean((globalThis as { __TCGEASY_PRERENDER__?: boolean }).__TCGEASY_PRERENDER__)
}

export default function SmartDocsRoute() {
  const { isAuthenticated, isLoading } = useAuth()

  // Static HTML generation runs in Node without session cookies; always render public docs shell.
  if (isPrerenderBuild()) {
    return (
      <PublicLayout>
        <Suspense fallback={<PageLoader />}>
          <Documentation />
        </Suspense>
      </PublicLayout>
    )
  }

  if (isLoading) {
    return <PageLoader />
  }

  // If logged in, show docs within the app layout
  if (isAuthenticated) {
    return (
      <MainLayout>
        <Suspense fallback={<PageLoader />}>
          <Documentation />
        </Suspense>
      </MainLayout>
    )
  }

  // If not logged in, show docs in public layout
  return (
    <PublicLayout>
      <Suspense fallback={<PageLoader />}>
        <Documentation />
      </Suspense>
    </PublicLayout>
  )
}
